import { render, staticRenderFns } from "./EmptyAccount.vue?vue&type=template&id=75f84321&"
import script from "./EmptyAccount.vue?vue&type=script&lang=ts&"
export * from "./EmptyAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports